import { OTA_Location } from "./ota_location.model";

export class OTA_VehRentalCore {
    public pickUpDateTime?: Date;
    public returnDateTime?: Date;
    public pickUpLocation = new OTA_Location();
    public returnLocation = new OTA_Location();
}